define([
    "dojo/_base/declare",
    "dojo/_base/lang",
    "dojo/when",
    "csi/action/Controller"
], function(declare,lang,when,Controller) {

	return declare(Controller, {
		process: function() {
			// summary: expand/collapse the clicked on element 
			this.setProgress();

			when(this.widget.plotExpandCollapse(this.m_element),
				lang.hitch(this, this.postProcess, true, null),
				lang.hitch(this, this.postProcess, false, null)
			);
		}
	});
});